{
  "changeChain": {
    "title": "체인 선택"
  },
  "checkoutBlocked": {
    "notAvailable": "사용할 수 없음",
    "regionMessage": "이 서비스는 귀하의 지역에서 사용할 수 없습니다.",
    "viewRegions": "사용 가능한 지역 보기."
  },
  "common": {
    "addressCopied": "주소가 복사됨",
    "back": "뒤로",
    "cancel": "취소",
    "close": "닫기",
    "confirm": "확인",
    "continue": "계속",
    "copied": "복사됨!",
    "copy": "복사",
    "copyAddress": "주소 복사",
    "done": "완료",
    "go": "이동",
    "loading": "불러오는 중…",
    "ok": "확인",
    "poweredBy": "Powered by",
    "tryAgain": "다시 시도",
    "startOver": "처음부터 다시"
  },
  "depositAmount": {
    "amountLabel": "금액",
    "changeToMaximum": "최대 금액으로 변경",
    "changeToMinimum": "최소 금액으로 변경",
    "delete": "삭제",
    "enterAmount": "금액을 입력하세요",
    "fee": "수수료 {{amount}}",
    "maximumAmount": "최대 입금액 {{amount}}",
    "minimumAmount": "최소 입금액 {{amount}}",
    "title": "입금",
    "submit": "입금",
    "submitWithMethod": "{{method}}로 입금"
  },
  "feeDetails": {
    "amount": "금액",
    "fee": "수수료 {{rate}}",
    "summaryAddedToCharge": "{{method}} 입금에는 {{rate}} 수수료가 발생하며, 총 결제 금액에 추가됩니다.",
    "summaryDeductedFromDeposit": "{{method}} 입금에는 {{rate}} 수수료가 발생하며, 수령 금액에서 차감됩니다.",
    "title": "수수료 세부 정보",
    "totalCost": "총 결제 금액",
    "youllGet": "수령 금액"
  },
  "fiat": {
    "agreeAndContinue": "약관에 동의하고 계속",
    "amountLabel": "입금 금액",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "Apple 지갑에 카드를 추가한 뒤 다시 시도하세요.",
    "applePayUnsupported": "이 기기에서는 Apple Pay로 결제할 수 없습니다.",
    "blocked": "귀하의 지역에서는 입금을 사용할 수 없습니다",
    "card": "카드",
    "contactVerifyBoth": "휴대폰 번호와 이메일 주소를 인증해 주세요",
    "contactVerifyEmail": "이메일 주소를 인증해 주세요",
    "contactVerifyPhone": "휴대폰 번호를 인증해 주세요",
    "countryHeading": "거주 국가",
    "countrySearchPlaceholder": "검색",
    "delete": "삭제",
    "deposit": "입금",
    "depositReceived": "{{amount}} 입금 완료",
    "depositReceivedFrom": "{{method}}에서",
    "emailPlaceholder": "이메일 주소",
    "failure": "입금 실패",
    "fee": "{{amount}} 수수료",
    "getNewPrice": "새 가격 받기",
    "kycConsentCheck": "Fun이 제 신원을 확인하고 그 결과를 주문을 처리하는 결제 제공업체와 공유하는 데 동의합니다. 자세한 내용은 다음을 참고하세요:",
    "kycConsentPrompt": "계속하면 Fun이 신원을 확인하고 그 결과를 주문을 처리하는 결제 제공업체와 공유하는 데 동의하게 됩니다. 자세한 내용은 다음을 참고하세요:",
    "kycConsentStop": ".",
    "kycDetailAddress": "주소를 입력해 주세요",
    "kycDetailDob": "생년월일을 입력해 주세요",
    "kycDetailName": "입금을 안전하게 보호하기 위해 신원 정보를 추가로 확인해야 합니다.",
    "kycDetailNationality": "국적",
    "kycDetailOther": "나머지 정보를 입력해 주세요",
    "kycDetailSsn": "9자리 SSN을 입력해 주세요",
    "kycFileUnsupported": "문서 업로드는 아직 이용할 수 없습니다. 곧 이 단계를 완료할 수 있게 됩니다.",
    "kycFormDetail": "첫 입금 전에 몇 가지 정보가 필요합니다.",
    "kycFormInvalid": "입력한 정보 중 일부를 다시 확인해 주세요.",
    "kycPhoneInUse": "이 전화번호는 이미 다른 {{provider}} 계정에서 사용 중입니다. 다른 번호를 입력해 주세요.",
    "kycTaxIdInUse": "이 세금 ID는 이미 다른 {{provider}} 계정에서 사용 중입니다.",
    "kycFormMissing": "필수 정보가 누락되었습니다.",
    "kycFormStale": "이 단계가 변경되었습니다. 아래 정보를 확인해 주세요.",
    "kycFormTitle": "신원 확인",
    "kycIntroDetail": "계정을 안전하게 유지하면서 입금을 처리하기 위해 필요합니다. 1분이면 완료되며 신분증은 필요하지 않습니다.",
    "kycNoticeCountryCode": "AU와 같은 두 자리 국가 코드를 입력해 주세요",
    "kycNoticeDateFormat": "YYYY-MM-DD 형식으로 입력해 주세요",
    "kycNoticeDatePast": "과거 날짜를 입력해 주세요",
    "kycNoticeInvalid": "강조된 항목을 확인해 주세요",
    "kycNoticeRequired": "강조된 항목을 입력해 주세요",
    "kycNoticeUnderage": "계속하려면 18세 이상이어야 합니다",
    "kycOnHold": "인증 보류 중",
    "kycOnHoldDetail": "나중에 다시 돌아와서 시도할 수 있습니다.",
    "kycOnHoldUntil": "{{date}}부터 다시 시도할 수 있습니다.",
    "kycOpenLink": "인증 계속하기",
    "kycOptional": "선택",
    "kycPrivacyPolicy": "개인정보처리방침",
    "kycProviderGeneric": "결제 제공업체",
    "kycProviderGenericId": "당사의 확인 파트너",
    "kycProviderTerms": "{{provider}}의 이용약관",
    "kycProviderTermsPrompt": "계속하면 다음에 동의하게 됩니다:",
    "kycRejected": "인증 실패",
    "kycRejectedSupport": "고객지원에 문의해 주시면 확인해 드립니다.",
    "kycRequired": "본인 확인 후 입금",
    "kycRequiredCta": "신분 확인 필요 →",
    "kycRequiredDetail": "입금을 계속하려면 본인 확인을 완료해 주세요.",
    "kycRequiredTitle": "본인 확인 필요",
    "kycCompleteDetail": "입금 한도가 상향되었습니다.",
    "kycCompleteTitle": "신분 확인이 완료되었습니다",
    "kycHardCta": "옵션 보기 →",
    "kycHardDetail": "신분 확인으로 입금 한도를 상향할 수 없습니다.",
    "kycHardTitle": "신분을 확인할 수 없습니다",
    "kycPendingCta": "확인 완료 대기 중 →",
    "kycPendingDetail": "최대한 빠르게 신분 확인을 완료하기 위해 처리하고 있습니다.",
    "kycPendingTitle": "신분 확인을 진행 중입니다",
    "kycSoftCta": "신분 확인 필요 →",
    "kycSoftDetail": "문제를 수정한 후 다시 시도할 수 있습니다.",
    "kycSoftTitle": "신분 확인에 실패했습니다",
    "kycOptionCloseDetail": "지금 나갔다가 나중에 이 입금으로 돌아올 수 있어요.",
    "kycOptionCloseTitle": "입금 닫기",
    "kycOptionMaxDetail": "신분 확인 전에는 {{max}}까지.",
    "kycOptionMaxDetailUnknown": "신분 확인 전에는 현재 한도까지.",
    "kycOptionMaxTitle": "최대 금액 입금",
    "kycOptionRedoDetail": "정보와 서류를 확인한 후 다시 시도해 보세요.",
    "kycOptionRedoTitle": "신분 확인 다시 하기",
    "kycOptionSupportDetail": "신분 확인 요건과 관련된 문제는 저희에게 문의해 주세요.",
    "kycOptionSupportTitle": "도움말 및 지원",
    "kycOptionsHardTitle": "신분 확인 후에도 입금 한도를 상향할 수 없습니다.",
    "kycOptionsLabel": "지금 가능한 작업:",
    "kycOptionsPendingTitle": "신분 확인을 아직 처리 중입니다. 입금 한도는 아직 변경되지 않았습니다.",
    "kycOptionsSoftTitle": "신분 확인에 실패했습니다. 지난 시도의 문제를 수정한 후 다시 확인해 보세요.",
    "kycTitle": "본인 확인",
    "otpDetailAnyEmail": "이메일로 코드를 보냈습니다",
    "otpDetailAnyPhone": "휴대폰으로 코드를 보냈습니다",
    "otpDetailEmail": "{{email}}(으)로 코드를 보냈습니다",
    "otpDetailPhone": "{{phone}}(으)로 코드를 보냈습니다",
    "otpError": "코드가 올바르지 않습니다. 확인 후 다시 시도해 주세요.",
    "otpExpired": "코드가 만료되었습니다. 새 코드를 요청해 주세요.",
    "otpRateLimited": "코드를 너무 많이 요청했습니다. 잠시 후 다시 시도해 주세요.",
    "otpRateLimitedTitle": "다른 코드를 요청하기 전에 잠시 기다려 주세요",
    "otpPlaceholder": "6자리 코드",
    "otpResend": "재전송",
    "otpResendPrompt": "코드를 받지 못하셨나요?",
    "otpTitle": "코드 입력",
    "payButton": "Apple Pay로 입금",
    "paySheetPay": "결제",
    "paySheetTitle": "Apple Pay로 확인",
    "paySheetTotal": "총 {{amount}}",
    "phoneCountryLabel": "국가 번호",
    "phoneCountrySearch": "국가 검색",
    "phonePlaceholder": "휴대폰 번호",
    "processing": "입금 처리 중…",
    "pendingOrderTitle": "완료되지 않은 입금이 있습니다",
    "pendingOrderDetail": "{{amount}} 입금을 재개하거나 취소하여 새 금액으로 계속하세요.",
    "resumeDeposit": "입금 재개",
    "cancelDeposit": "입금 취소",
    "quoteExpired": "해당 가격이 만료되었습니다",
    "quoteFailed": "가격을 가져오지 못했습니다",
    "redirectDetail": "돌아오시면 이 화면을 업데이트합니다.",
    "redirectReopen": "브라우저 다시 열기",
    "redirectTitle": "브라우저에서 결제를 완료하세요",
    "refunded": "입금이 환불되었습니다",
    "refusalDetails": "입력한 내용을 확인하고 다시 시도해 주세요.",
    "refusalDetailsTitle": "일부 정보를 다시 확인해 주세요",
    "refusalLimits": "더 적은 금액이나 다른 결제 수단을 시도해 주세요.",
    "refusalLimitsTitle": "이 결제 수단으로는 해당 금액을 처리할 수 없습니다",
    "refusalUnavailable": "저희 쪽 문제입니다. 잠시 후 다시 시도하거나 더 적은 금액을 시도해 주세요.",
    "refusalUnavailableTitle": "지금은 사용 가능한 결제 옵션이 없습니다",
    "requote": "새 견적 받기",
    "reviewTitle": "입금 확인",
    "orderConfirmingTitle": "결제를 확인하는 중",
    "orderConfirmingDetail": "결제가 완료되었습니다. 입금을 기록하는 중이며 잠시 시간이 걸릴 수 있습니다.",
    "submitFailed": "전송에 실패했습니다",
    "paymentFailed": "다시 시도해 주세요",
    "submitting": "제출 중",
    "stripeAuthDetail": "{{email}}을(를) 사용하여 Link에서 안전하게 계속합니다.",
    "stripeAuthorizing": "Stripe에서 계속",
    "stripeAuthorizingDetail": "Stripe 화면에서 Link 인증 및 동의를 완료하세요.",
    "stripeAuthTitle": "Stripe로 계속",
    "stripeAuthFailed": "Stripe 세션을 시작하지 못했습니다. 다시 시도해 주세요.",
    "stripeKycInfoFailed": "Stripe에 정보를 저장하지 못했습니다. 정보를 확인하고 다시 시도하세요.",
    "stripeRegistrationFailed": "Link 계정을 만들지 못했습니다. 정보를 확인하고 다시 시도하세요.",
    "success": "입금 완료",
    "successDetail": "잔액은 잠시 후 업데이트됩니다.",
    "termsNotice": "계속 진행하면 제공업체의\n<terms>약관</terms>에 동의하게 됩니다.",
    "unsupported": "이 단계는 아직 사용할 수 없습니다",
    "verifying": "신원을 확인하는 중…",
    "verifyingDetail": "보통 1분 이내에 완료됩니다.",
    "verifyingSlow": "계속 확인 중",
    "verifyingSlowDetail": "창을 닫고 잠시 후에 다시 확인해 주세요.",
    "coinbaseTermsNotice": "계속 진행하면 Coinbase의\n<terms>약관</terms>, <agreement>사용자 계약</agreement> 및 <privacy>개인정보 처리방침</privacy>에 동의하게 됩니다.",
    "contactInvalidEmail": "올바른 이메일 주소를 입력해 주세요",
    "kycIntroTitle": "본인 확인을 시작할게요",
    "kycAdditionalTitle": "정보가 조금 더 필요합니다",
    "kycAdditionalDetail": "입금 한도를 높이려면 추가 본인 확인이 필요합니다. 확인이 완료되면 높아진 한도를 즉시 이용할 수 있습니다.",
    "kycFindOutMore": "자세히 알아보기",
    "kycR2Consent": "계속하면 Fun이 본인 확인을 수행하고 그 결과를 일부 결제 서비스 제공업체와 공유하는 데 동의하게 됩니다.",
    "kycAgreeContinue": "동의하고 계속",
    "kycSsnLastFour": "SSN 마지막 4자리를\n입력해 주세요",
    "kycSsnProtection": "미국 법률에 따라 본인 확인을 위해 SSN을 수집해야 합니다. 고객님의 정보는 은행 수준의 암호화로 보호됩니다.",
    "kycDetailCountry": "거주 국가",
    "kycCountry": "국가",
    "kycDetailOccupation": "직업",
    "kycDetailPurpose": "거래 목적을 알려 주세요",
    "kycOccupation": "직업",
    "kycPurpose": "거래 목적",
    "kycDetailPhone": "휴대폰 번호",
    "kycDetailEmployment": "고용 상태",
    "kycDetailSourceOfWealth": "재산 출처",
    "kycDetailIncome": "연간 총소득",
    "kycDetailActivity": "월간 이용 활동",
    "kycIncomeCaption": "세전 금액, 현지 통화 기준",
    "kycReviewTitle": "감사합니다! 정보가 접수되어 검토 중입니다.",
    "kycHoldTitle": "감사합니다! 정보가 접수되었습니다. 검토를 완료하는 데 시간이 조금 더 필요합니다.",
    "kycRestrictedTitle": "계정이 제한되었습니다.",
    "regionUnsupportedTitle": "고객님의 지역은 지원되지 않습니다.",
    "kycAnyQuestions": "궁금한 점이 있으신가요?",
    "kycGetHelpSupport": "도움말 및 지원 받기",
    "otpVerified": "코드가 확인되었습니다",
    "authConnectFailedTitle": "{{provider}} 계정을 연결할 수 없습니다",
    "authConnectFailedDetail": "처음부터 다시 로그인하세요.",
    "kycUnavailableTitle": "현재 일시적으로 인증을 이용할 수 없습니다.",
    "kycUnavailableNetwork": "잠시 후 다시 시도하거나 나중에 돌아와 주세요.",
    "kycUnavailableProviderTitle": "인증을 완료하지 못했습니다.",
    "kycUnavailableProvider": "저희 쪽에서 문제가 발생했습니다. 고객 지원에 문의해 주시면 이어서 처리해 드리겠습니다.",
    "contactSupport": "고객 지원 문의",
    "kycDocumentTitle": "신분증 확인",
    "kycDocumentDetail": "본인 확인을 완료하려면 신분증을 확인해야 합니다. 신분증 확인은 {{provider}}에서 제공합니다.",
    "kycDocumentContinue": "{{provider}}(으)로 신분증 확인",
    "applePayUnavailableTitle": "Apple Pay를 일시적으로 사용할 수 없습니다.",
    "kycLimitNotice": "일일 한도에 도달했습니다. 지금 본인 확인을 완료하여 즉시 한도를 높이세요.",
    "contactEmailRejected": "이 이메일 주소를 확인할 수 없습니다. 다른 주소를 선택해 주세요.",
    "contactReverifyPhone": "전화번호를 다시 인증해 주세요.",
    "coinbaseCardSoftDeclined": "은행에서 결제를 거절했습니다. Apple Pay의 다른 카드를 사용하거나 은행에 문의하세요.",
    "coinbaseCardHardDeclined": "은행에서 이 카드를 거절했습니다. Apple Pay에서 다른 카드를 사용하세요.",
    "coinbaseCardRiskDeclined": "결제를 승인할 수 없습니다. Apple Pay에서 다른 카드를 사용해 보세요.",
    "coinbaseInvalidCard": "Apple Pay의 카드와 청구지 주소를 확인한 후 다시 시도하세요.",
    "coinbaseInsufficientBalance": "이 카드의 잔액으로는 입금할 수 없습니다.",
    "coinbasePrepaidCard": "선불카드는 사용할 수 없습니다. Apple Pay에서 체크카드를 사용하세요.",
    "coinbaseRegionUnsupported": "현재 위치에서는 카드 입금을 사용할 수 없습니다.",
    "coinbasePermissionDenied": "이 결제 수단은 회원님의 계정에서 사용할 수 없습니다.",
    "coinbaseWeeklyLimit": "주간 카드 입금 한도를 초과합니다. 더 적은 금액으로 시도하세요.",
    "coinbaseLifetimeCount": "Coinbase 계정 없이 이용할 수 있는 카드 입금 횟수를 모두 사용했습니다.",
    "coinbaseDailyCount": "오늘의 카드 입금 한도에 도달했습니다. 내일 다시 시도하세요.",
    "coinbaseBillingZip": "청구지 우편번호가 카드와 일치하지 않습니다. 확인 후 다시 시도하세요.",
    "coinbaseBillingAddress": "청구지 주소가 완전하지 않습니다. 확인 후 다시 시도하세요.",
    "coinbaseBillingName": "카드 소유자 이름이 승인되지 않았습니다. 확인 후 다시 시도하세요.",
    "coinbaseSessionExpired": "결제 세션이 만료되었습니다. 입금을 다시 시작하세요.",
    "coinbaseNetworkUnsupported": "현재 위치에서는 이 네트워크를 사용할 수 없습니다.",
    "coinbaseAssetUnsupported": "현재 위치에서는 이 토큰을 사용할 수 없습니다.",
    "coinbaseProviderError": "Coinbase에서 처리를 완료하지 못했습니다. 잠시 후 다시 시도하세요.",
    "coinbaseBuyFailed": "구매를 완료하지 못했습니다. 카드는 청구되지 않았습니다.",
    "coinbaseSendFailed": "입금을 전달하지 못했습니다. 카드로 환불됩니다.",
    "coinbaseAvsFailed": "청구지 주소를 확인하지 못했습니다. 은행에 확인한 후 다시 시도하세요.",
    "cancelled": "입금이 취소되었습니다",
    "sessionExpired": "세션이 만료되었습니다. 다시 로그인하여 입금을 계속하세요.",
    "accountIneligibleTitle": "이 계정에서는 입금을 이용할 수 없습니다",
    "accountIneligibleDetail": "오류라고 생각되면 지원팀에 문의하세요."
  },
  "fops": {
    "bankTransferSubtitle": "한도 {{limit}} · 1~2일",
    "bankTransferTime": "1~2일",
    "instant": "즉시",
    "limit": "한도 {{limit}}"
  },
  "networks": {
    "chainFallback": "체인 {{chainId}}",
    "minimum": "최소 ${{min}}"
  },
  "qrCode": {
    "title": "QR 코드"
  },
  "selectChain": {
    "subtitle": "입금할 네트워크를 선택하세요",
    "title": "암호화폐 입금"
  },
  "selectMethod": {
    "crypto": "암호화폐",
    "depositTo": "입금 대상",
    "errorMessage": "데이터를 불러오는 중 문제가 발생했습니다.\n인터넷 연결을 확인하고 다시 시도해 주세요.",
    "errorTitle": "문제가 발생했습니다",
    "loadingMethods": "결제 수단 불러오는 중",
    "noLimit": "제한 없음",
    "payWith": "결제 수단",
    "title": "자금 추가"
  },
  "selectReceiveToken": {
    "availableTokens": "사용 가능한 토큰",
    "moreTokens_other": "토큰 +{{count}}개",
    "searchTokens": "토큰 검색",
    "selectChain": "체인 선택",
    "selectToken": "토큰 선택",
    "title": "받을 토큰 및 체인"
  },
  "transferCrypto": {
    "changeChain": "체인 변경",
    "depositAddressLabel": "내 입금 주소",
    "generating": "생성 중…",
    "selectedChain": "선택된 체인",
    "share": "공유",
    "shareAddress": "주소 공유",
    "showQrCode": "QR 코드 표시",
    "title": "암호화폐 전송"
  },
  "withdraw": {
    "belowMinimumMessage": "잔액이 현금 출금 최소 금액보다 적습니다.",
    "belowMinimumTitle": "잔액 부족",
    "cashMethodsError": "현금 출금 수단을 불러오지 못했습니다. 암호화폐로는 출금할 수 있습니다.",
    "noCashMethods": "은행 및 카드 출금은 현재 지역에서 사용할 수 없습니다. 암호화폐로는 출금할 수 있습니다.",
    "title": "출금",
    "unavailableMessage": "현재 귀하의 지역에서는 현금 출금을 사용할 수 없습니다.",
    "unavailableTitle": "출금 불가"
  },
  "withdrawAddress": {
    "breakdown": "약 {{amount}}을 받게 됩니다. 네트워크 상황에 따라 조금 달라질 수 있습니다. 이 거래는 {{minimum}}보다 낮은 가격으로 실행되지 않습니다. 몇 초 안에 완료될 예정입니다.",
    "breakdownTitle": "거래 내역",
    "clear": "지우기",
    "detected": "지갑 확인됨",
    "notFound": "지갑을 찾을 수 없음",
    "paste": "붙여넣기",
    "requested": "출금 요청됨",
    "title": "{{amount}} 출금",
    "useConnected": "연결된 지갑 사용",
    "withdrawNow": "지금 출금",
    "withdrawing": "출금 중",
    "withdrew": "출금 완료",
    "youllReceive": "받는 금액"
  },
  "withdrawAmount": {
    "amountLabel": "금액",
    "delete": "삭제",
    "swapDenomination": "달러와 토큰 전환",
    "useMax": "최대 사용"
  },
  "withdrawCrypto": {
    "aboveBalance": "잔액 부족",
    "addressPlaceholder": "지갑 주소",
    "available": "{{amount}} {{symbol}} 사용 가능",
    "belowFee": "금액은 수수료 {{amount}}보다 커야 합니다",
    "belowMinimum": "최소 금액은 {{amount}}입니다",
    "ctaInvalidForChain": "이 네트워크에서 유효하지 않은 주소입니다",
    "ctaMaxExceeded": "최대 금액 초과",
    "ctaRecipientSameAsSource": "다른 주소를 선택하세요",
    "ctaSelectDestination": "받을 대상을 선택하세요",
    "errorGeneric": "출금에 실패했습니다. 다시 시도해 주세요.",
    "errorInsufficientGas": "가스가 부족합니다.",
    "errorSwitchChain": "네트워크를 전환할 수 없습니다. 지갑이 해당 네트워크를 지원하는지 확인해 주세요.",
    "failedMessage": "{{amount}}이(가) 수취인에게 도달하지 않았습니다. 자금이 돌아오지 않으면 고객지원에 문의하세요.",
    "failedTitle": "출금이 완료되지 않았습니다",
    "max": "최대",
    "methodSubtitle": "한도 없음",
    "methodTitle": "암호화폐 주소",
    "quoteFailed": "스왑 견적을 가져오는 데 실패했습니다. 다시 시도해 주세요.",
    "receiveAs": "받을 자산",
    "refundedMessage": "{{amount}}이(가) 지갑으로 반환되었습니다.",
    "riskyAddress": "제한으로 인해 이 지갑 주소를 사용할 수 없습니다.",
    "selectSource": "출처 선택",
    "sendFrom": "출금 출처",
    "successPendingMessage": "{{amount}} 은(는) 온체인에서 처리 중입니다. 닫으셔도 됩니다.",
    "successPendingTitle": "출금 전송됨",
    "title": "암호화폐 출금",
    "unsupportedRecipient": "지원되지 않는 수신자 주소"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}}시간",
    "delayHoursMinutes": "{{hours}}시간 {{minutes}}분",
    "delayMinutes": "{{minutes}}분",
    "delaySecond": "1초",
    "delaySeconds": "{{seconds}}초",
    "fastDisclaimer": "USDC 퍼프스만 · 다중 체인 · 즉시",
    "fastDisclaimerUnified": "USDC만 · 다중 체인 · 즉시",
    "methodFast": "빠른",
    "methodSecure": "네이티브 브리지",
    "secureDisclaimer": "모든 토큰 · 이더리움 체인만 · {{delay}}",
    "secureFallbackDelay": "60분 이상"
  },
  "withdrawNado": {
    "errorAmountTooLow": "금액이 너무 적어 Nado 출금 수수료를 충당할 수 없습니다.",
    "errorBalanceChanged": "출금 가능 잔액이 변경되었습니다. 최대를 누른 후 다시 시도해 주세요.",
    "errorInvalidNonce": "이 출금 요청이 만료되었습니다. 다시 시도해 주세요.",
    "errorNetwork": "현재 Nado에 연결할 수 없습니다. 다시 시도해 주세요.",
    "errorNoPriorDeposit": "출금하기 전에 Nado에 입금하세요.",
    "errorRateLimited": "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.",
    "errorSignerMismatch": "출금하려면 이 Nado 계정을 소유한 지갑으로 다시 전환하세요.",
    "errorUnconfirmed": "출금을 확인할 수 없습니다. 다시 시도하기 전에 Nado 잔액을 확인하세요.",
    "errorWithdrawRisk": "Nado의 24시간 출금 한도에 도달했습니다. 나중에 다시 시도해 주세요."
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "카드"
  },
  "lockedTransfer": {
    "amountInfoTitle": "보낼 금액",
    "amountInfoDescription": "{{amount}}을(를) 입금하기 위해 보내야 하는 금액입니다. 이 금액을 초과하여 보낸 자금은 입금되지 않으며, 회수하려면 고객 지원이 필요합니다.",
    "amountLoading": "계산 중…",
    "amountUnavailable": "금액을 가져올 수 없습니다",
    "title": "암호화폐 입금",
    "send": "보내기",
    "amount": "금액",
    "address": "일회용 입금 주소",
    "copyAmount": "금액 복사",
    "amountCopied": "금액 복사됨",
    "showFullAddress": "전체 주소 표시",
    "tokenOnChain": "{{chain}}의 {{token}}"
  },
  "selectAsset": {
    "emptyChains": "지원되는 네트워크가 없습니다",
    "combinedTitle": "보낼 토큰 및 네트워크",
    "title": "자산 선택",
    "empty": "지원되는 자산이 없습니다"
  }
}
